import type { ArticleInfoProps } from './ArticleInfo';
import { ArticleInfo } from './ArticleInfo';
import * as style from './Header.module.css';

export default function Header({ title, ingress, ...articleInfo }: { title?: string; ingress?: string } & ArticleInfoProps) {
    return (
        <header className={style.header}>
            <h1>{title}</h1>
            {ingress && <p>{ingress}</p>}
            <ArticleInfo {...articleInfo} />
        </header>
    );
}
